import React from 'react'
import { ScrollView, View } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { ScreenAuthProps } from '@navigation'
import { Button, Icon, KeyboardAwareView, Screen } from '@components'
import { useLanguage } from '@context'
import { useRegistrationSteps } from './hook'
import { ProgressBar } from './../components'
import { Step1Form, Step2Form, Step3Form } from './../steps'
import getStyle from './style'

export const RegistrationSteps: React.FC<ScreenAuthProps<'RegistrationSteps'>> = ({
  route,
  navigation,
}) => {
  const { t } = useLanguage()

  const theme = useTheme()
  const styles = getStyle(theme)

  const { scrollViewRef, currentStep, isPending, handleNext, handleBack } = useRegistrationSteps(
    navigation
  )

  const handleSkip = () => {
    // Logique pour passer l'étape actuelle
    handleNext({})
  }

  return (
    <KeyboardAwareView isFullScreen>
      <Screen isPending={isPending}>
        <View style={styles.header}>
          <View style={styles.navigationContainer}>
            <View style={styles.backContainer}>
              <Icon name="arrowBack" onPress={handleBack} />
            </View>
            <ProgressBar step={currentStep + 1} totalSteps={3} />
            <View style={styles.skipContainer}>
              {/*<Button
                title={t('registerSteps.skip')}
                onPress={handleSkip}
                unfilled
                isSmall
                customHeight={30}
                containerStyle={{ width: 'auto' }}
              />
              */}
            </View>
          </View>
          <View style={styles.divider} />
        </View>

        <ScrollView
          ref={scrollViewRef}
          horizontal
          pagingEnabled
          scrollEnabled={false}

          showsHorizontalScrollIndicator={false}
        >
          <Step1Form onSubmit={handleNext} />
          <Step2Form onSubmit={handleNext} />
          <Step3Form onSubmit={handleNext} />
        </ScrollView>
      </Screen>
    </KeyboardAwareView>
  )
}
